module.exports = __webpack_public_path__ + "static/media/mobile.0da8a626.png";